import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import Constants from "../../../../Constants.json";
import InvelpsAuth from "./InvelpsAuth";

export default function InvelpsLogin({
  googleAuthUrl = "/auth/google",
  linkedinAuthUrl = "/auth/linkedin",
}) {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const loginSubmit = async ({ email, password }) => {
    const base = (Constants.BACKEND_SERVER_BASE_URL || "").replace(/\/$/, "");
    const res = await fetch(`${base}/token/`, {
      method: "POST",
      body: JSON.stringify({ username: email, password }),
      headers: { "Content-Type": "application/json" },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data?.detail || data?.error || "Identifiants incorrects.");
    }
    const expirationTime = new Date(new Date().getTime() + 86400 * 1000);
    authCtx.login(data.access, data.refresh, data.role, expirationTime.toISOString());
    setTimeout(() => navigate("/capital"), 600);
  };

  return (
    <InvelpsAuth
      initialPage="login"
      googleAuthUrl={googleAuthUrl}
      linkedinAuthUrl={linkedinAuthUrl}
      loginSubmit={loginSubmit}
      onForgotPassword={() => navigate("/forgotpassword")}
      onGoSignup={() => navigate("/signup")}
    />
  );
}
